import { Route } from 'vue-router'
import { getTokenFromCookie, hasApiAuthToken } from '@/utils/token'
import { getVliveId } from '@/utils/vlive_id'
import { UAParser } from 'ua-parser-js'
import { baseURL } from '../api/baseURL'
import nodeServerApi from '../api/nodeServer'
import store from '../store'

const ua = window.navigator.userAgent
const uaParser = new UAParser(ua)
const isWebview = getTokenFromCookie() !== undefined

export function getUserOS() {
  return uaParser.getOS().name || ''
}

export function getWebViewer() {
  // Cookieからtokenを取得できるならWebViewからアクセスという判定
  let webViewer = ''
  if (isWebview) {
    webViewer = 'WebView'
  } else {
    // WebView以外なら使用しているブラウザーを取得
    const browserName = uaParser.getBrowser().name
    webViewer = browserName !== undefined ? browserName : 'unknown'
  }
  return webViewer
}

export async function sendAccessLog(
  to: Route,
  isSkipLoggingAccessGetVliveId = false
) {
  const referrer = store.state.referrer
  // isSkipLoggingAccessGetVliveIdがtrueの場合はgetVliveId()を実行せずvliveIdを空文字にする
  // api()がAuthorizationヘッダーを付与できないトークン未保持時の場合も認証エラー(401)多発を防止するためスキップする
  const vliveId =
    isSkipLoggingAccessGetVliveId || !hasApiAuthToken()
      ? ''
      : await getVliveId()
  const os = getUserOS()
  const webViewer = getWebViewer()

  nodeServerApi.loggingAccess
    ._({
      url: baseURL + to.fullPath,
      vliveId: vliveId === undefined ? '' : vliveId,
      os: os,
      webViewer: webViewer,
      referrer: referrer,
    })
    .catch(() => {
      // リクエストが飛べばいいので、レスポンスでエラーが出てもスルーする
    })

  return
}
